// extracted by mini-css-extract-plugin
export default {"previewContainer":"ProductLogo_previewContainer__zlKWO","preview":"ProductLogo_preview__hLr8E","badge":"ProductLogo_badge__mZieC"};